import { render, staticRenderFns } from "./ViewComponentesWrapper.vue?vue&type=template&id=3894969e&"
import script from "./ViewComponentesWrapper.vue?vue&type=script&lang=js&"
export * from "./ViewComponentesWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports